export const THEMES = {
  MODERN: {
    id: "MODERN",
    name: "Editorial Light",
    isDark: false,
    hasDarkVariant: false,
    bg: "bg-[#f7f7f6]",
    text: "text-[#232124]",
    card: "bg-white border-[#e8e6e4] shadow-none",
    border: "border-[#e8e6e4]",
    header: "bg-white border-[#e8e6e4]",
    navActive: "bg-[#f1eeec] text-[#241e20]",
    navInactive: "text-[#676166] hover:bg-[#f7f5f4] hover:text-[#241e20]",
    radius: "rounded-md",
    cardRadius: "rounded-[10px]",
    fontClass: "font-sans",
    positive: "text-[#0e6b56]",
    negative: "text-[#a22020]",
    primary: "text-[#241e20]",
    palette: ["#241e20", "#0e6b56", "#b98a2e", "#7d8793", "#a22020"],
  },
  MODERN_DARK: {
    id: "MODERN_DARK",
    name: "Editorial Dark",
    isDark: true,
    hasDarkVariant: false,
    bg: "bg-[#131314]",
    text: "text-white",
    card: "bg-[#1E1F20] border-[#353238] shadow-none",
    border: "border-[#353238]",
    header: "bg-[#181719] border-[#353238]",
    navActive: "bg-[#363136] text-white",
    navInactive: "text-slate-400 hover:bg-[#29262b] hover:text-white",
    radius: "rounded-md",
    cardRadius: "rounded-[10px]",
    fontClass: "font-sans",
    positive: "text-emerald-400",
    negative: "text-rose-400",
    primary: "text-sky-400",
    palette: ["#d8d2ce", "#39a889", "#d0a755", "#8c929c", "#e07070"],
  },
};

export const DARK_TOGGLE_MAP = {
  MODERN: "MODERN_DARK",
  MODERN_DARK: "MODERN",
};
